<template>
	<transition name="slide-right">
		<div class="announcements sidebar rightbar">
			<header class="header">
				<button type="button" class="btn btn-icon close-dialog" @click="$emit('close')">
					<i class="material-icons">close</i>
				</button>
				<ul class="header-tabs">
					<li :class="{ 'selected': tab === 'new' }" @click="tab = 'new'">{{ $t('What\'s New') }}</li>
					<li :class="{ 'selected': tab === 'roadmap' }" @click="tab = 'roadmap'">{{ $t('Roadmap') }}</li>
				</ul>
			</header>

			<!-- News Content -->
			<div class="news-content" v-if="tab === 'new'">
				<div class="news-item" v-for="(update, index) in completedUpdates" :key="index">
					<div class="news-date">{{ moment(update.release_date).format('MMM DD, YYYY') }}</div>
					<h2 v-if="update.link !== ''">
						<a :href="update.link" target="_blank">{{ update.title }}</a>
					</h2>
					<h2 v-else>{{ update.title }}</h2>
					<a
						class="news-image d-block"
						target="_blank"
						:href="update.picture"
						v-if="update.picture && update.picture !== ''">
						<img :src="update.picture" :alt="update.title">
					</a>
					<div class="news-description" v-html="formatDesc(update.description)"></div>
					<a
						:href="update.link"
						class="news-link"
						target="_blank"
						v-if="update.link !== ''">
						{{ $t('_.readMore') }}
					</a>
				</div>
			</div>

			<!-- Roadmap -->
			<div class="roadmap-content" v-if="tab === 'roadmap'">
				<section class="roadmap-section upcoming">
					<h2>{{ $t('Upcoming') }}</h2>
					<ul class="roadmap-list">
						<li class="roadmap-list-item" v-for="(update, index) in upcomingUpdates" :key="index">
							<span>{{ update.title }}</span>
							<span class="roadmap-date">{{ update.estimated_release_date }}</span>
						</li>
					</ul>
				</section>
				<section class="roadmap-section completed">
					<h2>{{ $t('Completed') }}</h2>
					<ul class="roadmap-list">
						<li class="roadmap-list-item" v-for="(update, index) in completedUpdates" :key="index">
							<span>{{ update.title }}</span>
							<span class="roadmap-date">{{ moment(update.release_date).format('DD/MM/YY') }}</span>
						</li>
					</ul>
				</section>
			</div>
		</div>
	</transition>
</template>

<script>
import { mapGetters } from 'vuex';
import { nl2br, sanitizeHtml } from '@/lib/helper';

export default {
	name: 'announcements',
	props: {
		visible: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			tab: 'new', // new / roadmap
		};
	},
	methods: {
		formatDesc(description) {
			return sanitizeHtml(nl2br(description));
		},
	},
	computed: {
		...mapGetters({
			announcements: 'announcements',
		}),
		updates() {
			return this.announcements.filter(announcement => announcement.type === 'update');
		},
		upcomingUpdates() {
			return this.updates.filter(announcement => !announcement.is_active);
		},
		completedUpdates() {
			return this.updates.filter(announcement => announcement.is_active);
		},
	},
};
</script>

<style lang="scss">
@import '../assets/scss/modules/_variables.scss';

.announcements {
	.header {
		position: relative;
		// padding-top: 40px;
		// height: 30px;
		flex-shrink: 0;
		flex-grow: 0;
		user-select: none;

		.btn {
			padding: 0;
			margin: 0;
			background: 0 0;
			border: 0;
			color: inherit;
			line-height: normal;
			outline: 0;
			vertical-align: middle;
		}
	}

	.header-tabs {
		display: flex;
		margin: 0;
		padding: 0;
		font-weight: 600;
		letter-spacing: .5px;
		text-transform: uppercase;

		li {
			margin-right: 10px;
			padding: 0 8px 5px;
			list-style: none;
			border-bottom: 3px solid transparent;
			cursor: pointer;

			&.selected {
				// color: #11b683;
				// border-color: #11b683;
				color: $color__primary;
				border-color: $color__primary;
			}
		}
	}

	.close-dialog {
		position: absolute;
		right: 14px;
		// bottom: 3px;
	}
}

.news-content {
	padding: 20px;
	overflow-y: auto;
}

.news-item {
	position: relative;
	margin-bottom: 30px;
	padding-bottom: 20px;
	border-bottom: 1px solid #ddd;

	h2 {
		margin: 2px 0 10px;
		font-size: 20px;
	}
}

.news-date {
	color: rgba(0,0,0,.5);
	font-size: 12px;
	font-weight: 600;
	text-transform: uppercase;
	letter-spacing: .5px;
}

.news-image {
	margin-bottom: 1em;
	text-align: center;

	img {
		max-width: 100%;
	}
}

.news-description {
	margin-bottom: 10px;
	font-size: 14px;
	line-height: 20px;
	text-align: justify;
}

.roadmap-content {
	overflow-y: auto;
}

.roadmap-section {
	padding: 20px;

	&.completed {
		border-top: 1px solid #ddd;
	}

	h2 {
		margin-bottom: .75em;
		font-size: 1.25em;
		font-weight: 600;
		color: rgba(0,0,0,.6);
	}
}

.roadmap-list {
	margin: 0;
	padding: 0;
}

.roadmap-list-item {
	display: flex;
	position: relative;
	margin: 5px 0;
	list-style: none;
	justify-content: space-between;
	align-items: center;
}

.roadmap-date {
	color: rgba(0,0,0,.5);
	font-size: 12px;
	font-weight: 600;
	text-transform: uppercase;
	letter-spacing: .5px;
}
</style>
